// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";

const AvailabilityFilterBar = ({
  filters,
  onFilterChange,
  locationOptions = [],
  scenarioOptions = [],
}) => {
  return (
    <div
      className="av-filterbar"
      role="search"
      aria-label="Belegte Tage filtern"
    >
      <label htmlFor="av-filter-location" className="av-sr-only">
        Standort
      </label>
      <select
        id="av-filter-location"
        value={filters.location}
        onChange={(e) => onFilterChange("location", e.target.value)}
        aria-label="Standort"
      >
        {locationOptions.length === 0 && (
          <option value="">Standorte werden geladen …</option>
        )}
        {locationOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <label htmlFor="av-filter-scenario" className="av-sr-only">
        Szenario
      </label>
      <select
        id="av-filter-scenario"
        value={filters.scenario}
        onChange={(e) => onFilterChange("scenario", e.target.value)}
        aria-label="Szenario"
      >
        {scenarioOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <label htmlFor="av-filter-source" className="av-sr-only">
        Datenquelle
      </label>
      <select
        id="av-filter-source"
        value={filters.source}
        onChange={(e) => onFilterChange("source", e.target.value)}
        aria-label="Datenquelle"
      >
        <option value="all">Alle Quellen</option>
        <option value="booking">Buchung</option>
        <option value="seas">SEAS-Microservice</option>
      </select>
    </div>
  );
};

export default AvailabilityFilterBar;
